var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roleVal == 'admin' || _vm.roleVal == 'staff')?_c('dashboard-admin',{staticClass:"mt-4"}):(_vm.roleVal == 'vendor')?_c('dashboard-vendor',{staticClass:"mt-4"}):(_vm.roleVal == 'tenant')?_c('dashboard-tenant',{staticClass:"mt-4"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }